import { render, staticRenderFns } from "./kollist.vue?vue&type=template&id=61aa1c4b&scoped=true"
import script from "./kollist.vue?vue&type=script&lang=js"
export * from "./kollist.vue?vue&type=script&lang=js"
import style0 from "./kollist.vue?vue&type=style&index=0&id=61aa1c4b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61aa1c4b",
  null
  
)

export default component.exports